import { BestLabel, BrowseFiles, Icon } from "best-common-react";
import styled from "styled-components";

const Logo = styled.img.attrs(() => ({
  alt: "Logo To Upload",
  className: "img-fluid mx-auto d-block",
}))`
  max-height: 14rem;
`;

const DeleteIcon = styled(Icon).attrs(() => ({
  className: "p-2",
}))``;

const LogoUploadSection = ({ label, logo, onFileAdd, onFileDelete, headerClassName = "mr-2" }) => {
  return (
    <div className={headerClassName}>
      <BestLabel>{label}</BestLabel>
      <div className="d-flex align-items-center">
        <div className="col">
          <BrowseFiles
            onFileAdd={onFileAdd}
            onFileDelete={onFileDelete}
            fileTypes={["image/png", "image/jpg", "image/jpeg"]}
          />
        </div>
        <div className="col">
          {logo?.fileBase64String?.length ? (
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="d-flex">
                <Logo src={logo.fileBase64String} />
                <DeleteIcon iconName="fa-times-circle" onClick={onFileDelete} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LogoUploadSection;
